import api from "./Api";

class GerenciadorNFSeService {
  PadroesDisponiveis() {
    return api
      .get("/v1/GerenciadorNFSe/PadroesDisponiveis")
      .then((response) => {
        return response.data;
      });
  }

  TransmitirNota(payload) {
    return api
      .get("/v1/GerenciadorNFSe/TransmitirNota?nota=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  ConsultarNota(payload) {
    const nota = typeof payload === "object" ? payload.id : payload;
    const chaveAcesso =
      typeof payload === "object" ? payload.chaveAcesso || "" : "";

    return api
      .get(
        "/v1/GerenciadorNFSe/ConsultarNota?nota=" +
          nota +
          "&chaveAcesso=" +
          encodeURIComponent(chaveAcesso)
      )
      .then((response) => {
        return response.data;
      });
  }

  CancelarNota(payload) {
    return api
      .put("/v1/GerenciadorNFSe/CancelarNota?nota=" + payload.id, {
        justificativa: payload.justificativa,
        codigo_cancelamento: payload.codigo_cancelamento,
      })
      .then((response) => {
        return response.data;
      });
  }

  ImprimirNota(payload) {
    return api
      .get("/v1/GerenciadorNFSe/ImprimirNota/" + payload, {
        responseType: "blob",
      })
      .then((response) => {
        return response;
      });
  }

  DownloadXMLNFSe(payload) {
    return api
      .get("/v1/GerenciadorNFSe/DownloadXMLNFSe?id=" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new GerenciadorNFSeService();
